import Amplify, { Auth, Storage } from "aws-amplify";
import Joi from "joi-browser";
import _ from "lodash";
import { createRef } from "react";
import Lottie from "react-lottie-player";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { addBGGame, getGame, loadBGGames, updateBGGame } from "store/games";
import { getSettings, loadSettings } from "store/settings";
import { v4 as uuidv4 } from "uuid";

//  Images
import deleteIcon from "include/images/delete-icon.svg";
import plusIcon from "include/images/plus-1.svg";
import placeholderJson from "include/json/placeholder-img.json";

//  Components
import AlertError from "common/alert/alertError";
import AlertSuccess from "common/alert/alertSuccess";
import Form from "common/form/form";
import Select from "common/form/selectSearch";
import NextButton from "common/form/submitButton";
import Header from "common/header";
import Loader from "common/loader";
import SideBar from "common/sidebar";
import { ELEMENT_OPTIONS, RARITY_OPTIONS } from "utils/constants";

//  Amplify Configuration
Amplify.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,
    region: "us-east-1",
  },
  Storage: {
    bucket: process.env.REACT_APP_S3BUCKET,
    region: "us-east-1",
  },
});
Auth.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID, //REQUIRED - Amazon Cognito Identity Pool ID
    region: "us-east-1", // REQUIRED - Amazon Cognito Region
  },
  Storage: {
    bucket: process.env.REACT_APP_S3BUCKET, //REQUIRED -  Amazon S3 bucket
    region: "us-east-1",
  },
});

class AddBGGame extends Form {
  ref = createRef(null);

  prizesOptions = [
    { name: "Point", value: "point" },
    { name: "Gear", value: "gear" },
  ];
  missionCompletedRewardTypeOptions = [
    // { name: "Points", value: 1 },
    { name: "USDT", value: 2 },
    { name: "Gear", value: 3 },
  ];
  state = {
    data: {
      name: "",
      subtitle: "",
      gameEndDelay: "",
      url: "",
      telegramGameURL: "",
      category: {},
      description: "",
      telegramAppImage: null,
      telegramMissionImage: null,

      applicableForTelegramGame: { name: "No", value: false },
      missionCompletedRewardType: this.missionCompletedRewardTypeOptions[0],
      gameType: { name: "Skill Based Game", value: 0, data: null },

      displayOrder: null,
      maxTimeSpan: "",
      gameEncryptionKey: "",
      applicableForBoardGame: { name: "No", value: false },
      levelOneScore: 0,
      levelOneMultiplier: 0,
      levelOnePrizeType: this.prizesOptions[0],
      levelOneQuantity: 0,
      levelOneRarity: RARITY_OPTIONS[0],
      levelOneElement: ELEMENT_OPTIONS[0],
      levelTwoScore: 0,
      levelTwoMultiplier: 0,
      levelTwoPrizeType: this.prizesOptions[0],
      levelTwoQuantity: 0,
      levelTwoRarity: RARITY_OPTIONS[0],
      levelTwoElement: ELEMENT_OPTIONS[0],

      levelThreeScore: 0,
      levelThreeMultiplier: 0,
      levelThreePrizeType: this.prizesOptions[0],
      levelThreeQuantity: 0,
      levelThreeRarity: RARITY_OPTIONS[0],
      levelThreeElement: ELEMENT_OPTIONS[0],

      levelFourScore: 0,
      levelFourMultiplier: 0,
      levelFourPrizeType: this.prizesOptions[0],
      levelFourQuantity: 0,
      levelFourRarity: RARITY_OPTIONS[0],
      levelFourElement: ELEMENT_OPTIONS[0],

      missionCompletedReward: 0,
      missionCompletedRewardRarity: RARITY_OPTIONS[0],
      missionCompletedRewardElement: ELEMENT_OPTIONS[0],
    },
    id: "",
    edit: false,
    errors: {},
    loadingBGGame: false,

    loadingTelegramMissionImage: false,
    loadingTelegramAppImage: false,
    settingsLoading: false,
    telegramMissionImageChange: false,
    telegramAppImageChange: false,
  };
  gameTypeOptions = [
    { name: "Skill Based Game", value: 0, data: null },
    { name: "Luck Based Live Game", value: 1, data: null },
    { name: "Luck Based Slot Game", value: 2, data: null },
  ];
  componentDidUpdate = (prevProps, prevState) => {
    if (!this.props.getGame.loading && this.props.getGame.loading !== prevProps.getGame.loading)
      this.ref.current.complete();

    if (this.props.getGame.loading && this.props.getGame.loading !== prevProps.getGame.loading)
      this.ref.current.continuousStart();
  };
  componentDidMount = () => {
    this.loadOptionSettings();
    const data = { ...this.state.data };

    if (this.props.location.state) {
      const game = this.props.location.state.game;
      data.name = game.name;
      const { settings } = this.props.getSettings;
      const categoryList = settings?.length > 0 ? structuredClone(settings[0]?.question?.categories) : [];
      const cat = categoryList.find((c) => c.name === game.category);
      data.category = cat
        ? {
            name: cat.name,
            value: cat.name,
            data: cat,
          }
        : {};

      data.url = game.url;
      data.telegramGameURL = game.telegramGameURL ?? "";

      data.applicableForTelegramGame = {
        name: game?.applicableForTelegramGame ? "Yes" : "No",
        value: game?.applicableForTelegramGame ?? false,
        data: null,
      };
      data.applicableForBoardGame = {
        name: game?.applicableForBoardGame ? "Yes" : "No",
        value: game?.applicableForBoardGame ?? false,
        data: null,
      };
      data.subtitle = game.subtitle;
      data.gameEndDelay = `${game.gameEndDelay}` ?? "";
      data.maxTimeSpan = game.maxTimeSpan ? `${game.maxTimeSpan}` : "";

      data.gameEncryptionKey = game.gameEncryptionKey ? `${game.gameEncryptionKey}` : "";
      data.telegramAppImage = { original: game.telegramAppImage };

      data.description = game.description;
      if (game?.displayOrder) data.displayOrder = { name: `${game?.displayOrder}`, value: game?.displayOrder };
      data.gameType = this.gameTypeOptions[game?.gameType ?? 0];
      data.telegramMissionImage = game.telegramMissionImage;
      if (game.levelThresholds) {
        const levels = ["one", "two", "three", "four"];
        levels.forEach((level) => {
          data[`level${level.charAt(0).toUpperCase() + level.slice(1)}Score`] = game.levelThresholds[level]?.score;
          data[`level${level.charAt(0).toUpperCase() + level.slice(1)}Multiplier`] =
            game.levelThresholds[level]?.multiplier ?? 0;
          data[`level${level.charAt(0).toUpperCase() + level.slice(1)}PrizeType`] = game.levelThresholds[level]
            ?.prizeType
            ? this.prizesOptions.find((prize) => prize?.value === game.levelThresholds[level]?.prizeType)
            : this.prizesOptions[0];
          data[`level${level.charAt(0).toUpperCase() + level.slice(1)}Quantity`] =
            game.levelThresholds[level]?.quantity ?? 0;
          data[`level${level.charAt(0).toUpperCase() + level.slice(1)}Rarity`] = game.levelThresholds[level]?.rarity
            ? RARITY_OPTIONS?.find((rarity) => rarity?.value === game.levelThresholds[level]?.rarity)
            : RARITY_OPTIONS[0];
          data[`level${level.charAt(0).toUpperCase() + level.slice(1)}Element`] = game.levelThresholds[level]?.element
            ? ELEMENT_OPTIONS?.find((element) => element?.value === game.levelThresholds[level]?.element)
            : ELEMENT_OPTIONS[0];
        });
      }
      data.missionCompletedRewardType = game?.missionCompletedRewardType
        ? this.missionCompletedRewardTypeOptions.find((rarity) => rarity?.value === game?.missionCompletedRewardType)
        : this.missionCompletedRewardTypeOptions[0];
      data.missionCompletedReward = game?.missionCompletedReward ?? 0;
      data.missionCompletedRewardRarity = game?.rarity
        ? RARITY_OPTIONS.find((rarity) => rarity?.value === game?.rarity)
        : RARITY_OPTIONS[0];
      data.missionCompletedRewardElement = game?.element
        ? ELEMENT_OPTIONS?.find((element) => element?.value === game?.element)
        : ELEMENT_OPTIONS[0];
      this.setState({ data, edit: true, id: game.id });
    }
  };
  doSubmit = (e) => {
    this.setState({ loadingBGGame: true });
    const {
      name,
      description,
      category,
      telegramMissionImage,
      url,
      telegramGameURL,
      subtitle,
      gameEndDelay,
      maxTimeSpan,
      gameEncryptionKey,
      applicableForTelegramGame,
      telegramAppImage,
      displayOrder,
      gameType,
      applicableForBoardGame,
      levelOneScore,
      levelOneMultiplier,
      levelOnePrizeType,
      levelOneQuantity,
      levelOneRarity,
      levelOneElement,
      levelTwoScore,
      levelTwoMultiplier,
      levelTwoPrizeType,
      levelTwoQuantity,
      levelTwoRarity,
      levelTwoElement,
      levelThreeScore,
      levelThreeMultiplier,
      levelThreePrizeType,
      levelThreeQuantity,
      levelThreeRarity,
      levelThreeElement,
      levelFourScore,
      levelFourMultiplier,
      levelFourPrizeType,
      levelFourQuantity,
      levelFourRarity,
      levelFourElement,
      missionCompletedRewardType,
      missionCompletedReward,
      missionCompletedRewardRarity,
      missionCompletedRewardElement,
    } = this.state.data;
    const payLoad = {
      name,
      description,
      category: category.value ?? "",
      url,
      telegramGameURL,
      subtitle,
      gameEndDelay: parseInt(gameEndDelay),
      scoringType: 2,

      applicableForTelegramGame: applicableForTelegramGame.value,
      applicableForBoardGame: applicableForBoardGame.value,
      gameType: gameType?.value,
      telegramAppImage: telegramAppImage?.original,
      telegramMissionImage:
        this.state.edit && !this.state.telegramMissionImageChange
          ? telegramMissionImage
          : telegramMissionImage?.original,

      gameEncryptionKey,
      otherGameDetails: {
        timer: false,
        score: false,
      },
    };
    if (displayOrder?.value) payLoad.displayOrder = displayOrder?.value;

    if (maxTimeSpan) payLoad.maxTimeSpan = parseInt(maxTimeSpan);

    const createLevelThreshold = (score, multiplier, prizeType, quantity, rarity, element) => {
      const threshold = {
        score: parseInt(score),
        multiplier: parseFloat(multiplier),
        prizeType: prizeType?.value,
        quantity: prizeType?.value === "gear" ? 1 : parseInt(quantity),
      };
      if (prizeType?.value === "gear") {
        threshold.rarity = rarity?.value;
        threshold.element = element?.value;
      }
      return threshold;
    };

    payLoad.levelThresholds = {
      one: createLevelThreshold(
        levelOneScore,
        levelOneMultiplier,
        levelOnePrizeType,
        levelOneQuantity,
        levelOneRarity,
        levelOneElement,
      ),
      two: createLevelThreshold(
        levelTwoScore,
        levelTwoMultiplier,
        levelTwoPrizeType,
        levelTwoQuantity,
        levelTwoRarity,
        levelTwoElement,
      ),
      three: createLevelThreshold(
        levelThreeScore,
        levelThreeMultiplier,
        levelThreePrizeType,
        levelThreeQuantity,
        levelThreeRarity,
        levelThreeElement,
      ),
      four: createLevelThreshold(
        levelFourScore,
        levelFourMultiplier,
        levelFourPrizeType,
        levelFourQuantity,
        levelFourRarity,
        levelFourElement,
      ),
    };

    payLoad.missionCompletedRewardType = missionCompletedRewardType?.value;
    payLoad.missionCompletedReward = missionCompletedRewardType?.value === 3 ? 1 : parseFloat(missionCompletedReward);
    if (missionCompletedRewardType?.value === 3) {
      payLoad.rarity = missionCompletedRewardRarity?.value;
      payLoad.element = missionCompletedRewardElement?.value;
    }
    if (this.state.edit) {
      this.props.updateBGGame(payLoad, this.state.id, (gameRes) => {
        this.setState({ loadingBGGame: false });
        if (gameRes.status === 200) {
          toast(<AlertSuccess message="Information Saved" />, {
            containerId: 1,
          });
          setTimeout(() => {
            this.props.history.push("/burn-ghost-games");
          }, 1000);
        } else {
          toast(<AlertError message={gameRes.data && gameRes.data.message} />, {
            containerId: 1,
          });
        }
      });
    } else {
      this.props.addBGGame(payLoad, (bgGameRes) => {
        this.setState({
          loadingBGGame: false,
        });
        if (bgGameRes.status === 200) {
          toast(<AlertSuccess message="Information Saved" />, {
            containerId: 1,
          });
          setTimeout(() => {
            this.props.history.push("burn-ghost-games");
          }, 1000);
        } else {
          toast(<AlertError message={bgGameRes.data && bgGameRes.data.message} />, {
            containerId: 1,
          });
        }
      });
    }
  };
  schema = {
    name: Joi.string()
      .max(500)
      .required()
      .error((errors) => {
        errors.forEach((err) => {
          switch (err.type) {
            case "any.empty":
              err.message = "Name is required.";
              break;
            case "string.max":
              err.message = "Title cannot be longer than 500 characters.";
              break;
          }
        });
        return errors;
      }),

    description: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((err) => {
          switch (err.type) {
            case "any.empty":
              err.message = "Description is required.";
              break;
          }
        });
        return errors;
      }),
    category: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow([""]),
    }),

    applicableForTelegramGame: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.boolean().allow(false),
    }),
    applicableForBoardGame: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.boolean().allow(false),
    }),

    maxTimeSpan: Joi.string().required(),

    missionCompletedRewardType: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.number().allow(""),
    }),
    gameEncryptionKey: Joi.string().allow(""),
    url: Joi.string().allow(""),
    telegramGameURL: Joi.string().allow(""),
    subtitle: Joi.string().allow(""),
    gameEndDelay: Joi.alternatives().try(Joi.string(), Joi.number()).required(),
    gameType: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.number().allow(""),
    }),
    levelOneScore: Joi.number().allow(""),
    levelOneMultiplier: Joi.number().allow(""),
    levelOneQuantity: Joi.number().allow(""),
    levelOneRarity: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    levelOneElement: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    levelOnePrizeType: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    levelTwoScore: Joi.number().allow(""),
    levelTwoMultiplier: Joi.number().allow(""),
    levelTwoQuantity: Joi.number().allow(""),
    levelTwoRarity: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    levelTwoElement: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    levelTwoPrizeType: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    levelThreeScore: Joi.number().allow(""),
    levelThreeMultiplier: Joi.number().allow(""),
    levelThreeQuantity: Joi.number().allow(""),
    levelThreeRarity: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    levelThreeElement: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    levelThreePrizeType: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    levelFourScore: Joi.number().allow(""),
    levelFourMultiplier: Joi.number().allow(""),
    levelFourQuantity: Joi.number().allow(""),
    levelFourRarity: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    levelFourElement: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    levelFourPrizeType: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    missionCompletedReward: Joi.number().allow(""),
    missionCompletedRewardRarity: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),
    missionCompletedRewardElement: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().allow(""),
    }),

    telegramAppImage: Joi.object().required(),

    telegramMissionImage: Joi.object().allow([{}, null]),

    displayOrder: Joi.object().allow([{}, null]),
  };

  onChange = (e) => {
    const data = this.state.data;
    const errors = this.state.errors;
    data[e.name] = e.currentTarget;
    delete errors[e.name];

    this.setState({ data, errors });
  };

  //  load lists of the dropdown
  loadOptionSettings = (data) => {
    this.setState({ settingsLoading: true });
    this.props.loadSettings(() => this.setState({ settingsLoading: false }));
  };

  handleImageChange = (e, type) => {
    const data = { ...this.state.data };
    const errors = { ...this.state.errors };
    this.setState({
      [type === "telegramAppImage" ? "loadingTelegramAppImage" : "loadingTelegramMissionImage"]: true,
    });
    const fSize = Math.round(e.target.files[0].size / 1048576);
    const fType = e.target.files[0].type;
    const ext = e.target.files[0].name.split(".").pop();
    if (fSize > 25) {
      toast(<AlertError message="Image size exceeds maximum allowable size. Maximum allowable size is 25MB." />, {
        containerId: 1,
      });
      return this.setState({ loadingImages: false });
    } else if (!["image/png", "image/jpeg", "image/jpg", "image/webp"].includes(fType)) {
      toast(
        <AlertError message="File is not of correct format and hence cannot be uploaded. Valid image formats are PNG, JPG, JPEG and WEBP." />,
        {
          containerId: 1,
        },
      );
      return this.setState({ loadingImages: false });
    } else {
      const fileName = uuidv4() + "." + ext;
      Storage.put(fileName, e.target.files[0], {
        completeCallback: (event) => {},
        progressCallback: (progress) => {},
        errorCallback: (err) => {},
      })
        .then((result) => {
          this.setState({
            errors,
            [type === "telegramAppImage" ? "loadingTelegramAppImage" : "loadingTelegramMissionImage"]: false,
            data: {
              ...this.state.data,
              [type === "telegramAppImage" ? "telegramAppImage" : "telegramMissionImage"]: {
                original: "public/" + result.key,
              },
            },
            [type === "telegramAppImage" ? "telegramAppImageChange" : "telegramMissionImageChange"]: true,
          });
          e.target.value = null;
        })
        .catch((error) => {
          e.target.value = null;
        });
    }
    this.setState({ data });
  };
  onTypeChange = (e) => {
    const data = { ...this.state.data };
    const errors = { ...this.state.errors };
    data[e.target.name] = !data[e.target.name];
    delete errors[e.target.name];
    this.setState({ data, errors });
  };

  render() {
    const { data, errors } = this.state;
    console.log("errors", errors);
    return (
      <>
        <Header history={this.props.history} />
        <Loader loaderRef={this.ref} />
        <div className="page-wrapper add-dev-server-wrapper">
          <SideBar page="bgGames" />

          <div className="main-content-wrapper position-relative">
            <div className="mcw-header d-flex align-items-center">
              <h1>{this.props.location.state ? "Edit" : "Add a"} BG Game</h1>
            </div>
            <div className="fwc-wrapper">
              <fieldset className="row fieldset">
                <div className="col-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="fml-box">{this.renderInput("name", "Name")}</div>
                    </div>
                    <div className="col-6">
                      <div className="fml-box">{this.renderInput("subtitle", "Subtitle")}</div>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="fml-box">{this.renderInput("url", "URL", "")}</div>
                </div>
              </fieldset>
              <fieldset className="row fieldset">
                <div className="col-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="fml-box">
                        {this.renderInput("gameEndDelay", "Game-end delay (in Millisecond)", "", "number")}
                      </div>
                    </div>

                    <div className="col-6 fml-box">
                      {this.renderInput("maxTimeSpan", "Max Time Span (In Seconds)", "", "number")}
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="fml-box">{this.renderInput("gameEncryptionKey", "Encryption Key", "")}</div>
                </div>
              </fieldset>
              <fieldset className="row fieldset">
                <div className="col-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="fml-box">
                        <div className="new-form-group">
                          <label className="form-label">Display Order</label>
                          <Select
                            name="displayOrder"
                            options={[...Array(50).keys()].map((i) => ({ name: `${i + 1}`, value: i + 1 }))}
                            label="Select Display Order"
                            value={this.state.data.displayOrder}
                            error={this.state.errors.displayOrder}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset className="row fieldset">
                <div className="col-6">
                  <div className="fml-box">{this.renderInput("telegramGameURL", "Telegram Mini App URL", "")}</div>
                </div>
                <div className="col-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="fml-box">
                        <div className="new-form-group">
                          <label className="form-label">Applicable for Telegram Mini App</label>
                          <Select
                            name="applicableForTelegramGame"
                            options={[
                              { name: "Yes", value: true, data: null },
                              { name: "No", value: false, data: null },
                            ]}
                            label=""
                            value={this.state.data?.applicableForTelegramGame}
                            error={this.state.errors?.applicableForTelegramGame}
                            onChange={this.onChange}
                            isLoading={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>{" "}
              <fieldset className="row fieldset">
                <div className="col-6">
                  <div className="new-form-group">
                    <label className="form-label">Game Type</label>
                    <Select
                      name="gameType"
                      options={this.gameTypeOptions}
                      label=""
                      value={this.state.data.gameType}
                      error={this.state.errors.gameType}
                      onChange={this.onChange}
                      isLoading={false}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="fml-box">
                        <div className="new-form-group">
                          <label className="form-label">Applicable for Board Game</label>
                          <Select
                            name="applicableForBoardGame"
                            options={[
                              { name: "Yes", value: true, data: null },
                              { name: "No", value: false, data: null },
                            ]}
                            label=""
                            value={this.state.data?.applicableForBoardGame}
                            error={this.state.errors?.applicableForBoardGame}
                            onChange={this.onChange}
                            isLoading={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset className="row fieldset">
                <label className="form-label text-uppercase gcdr-heading-filter">
                  <div className="gcdr-heading-text">Missions</div>
                </label>

                <div className="row">
                  <div className="col-3">
                    <div className="fml-box">{this.renderInput("levelOneScore", "Level One Score", "", "number")}</div>
                  </div>
                  <div className="col-3">
                    <div className="fml-box">
                      {this.renderInput("levelOneMultiplier", "Level One Multiplier", "", "number")}
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="fml-box">
                      <div className="new-form-group">
                        <label className="form-label">Level One Prize Type</label>
                        <Select
                          name="levelOnePrizeType"
                          options={this.prizesOptions}
                          label=""
                          value={this.state.data?.levelOnePrizeType}
                          error={this.state.errors?.levelOnePrizeType}
                          onChange={this.onChange}
                          isLoading={false}
                        />
                      </div>
                    </div>
                  </div>
                  {this.state.data?.levelOnePrizeType?.value === "point" ? (
                    <div className="col-2">
                      <div className="fml-box">
                        {this.renderInput("levelOneQuantity", "Level One Points", "", "number")}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="col-2">
                        <div className="fml-box">
                          <div className="new-form-group">
                            <label className="form-label">Level One Rarity</label>
                            <Select
                              name="levelOneRarity"
                              options={RARITY_OPTIONS}
                              label=""
                              value={this.state.data?.levelOneRarity}
                              error={this.state.errors?.levelOneRarity}
                              onChange={this.onChange}
                              isLoading={false}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-2">
                        <div className="fml-box">
                          <div className="new-form-group">
                            <label className="form-label">Level One Element</label>
                            <Select
                              name="levelOneElement"
                              options={ELEMENT_OPTIONS}
                              label=""
                              value={this.state.data?.levelOneElement}
                              error={this.state.errors?.levelOneElement}
                              onChange={this.onChange}
                              isLoading={false}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </fieldset>
              <fieldset className="row fieldset">
                <div className="row">
                  <div className="col-3">
                    <div className="fml-box">{this.renderInput("levelTwoScore", "Level Two Score", "", "number")}</div>
                  </div>
                  <div className="col-3">
                    <div className="fml-box">
                      {this.renderInput("levelTwoMultiplier", "Level Two Multiplier", "", "number")}
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="fml-box">
                      <div className="new-form-group">
                        <label className="form-label">Level Two Prize Type</label>
                        <Select
                          name="levelTwoPrizeType"
                          options={this.prizesOptions}
                          label=""
                          value={this.state.data?.levelTwoPrizeType}
                          error={this.state.errors?.levelTwoPrizeType}
                          onChange={this.onChange}
                          isLoading={false}
                        />
                      </div>
                    </div>
                  </div>
                  {this.state.data?.levelTwoPrizeType?.value === "point" ? (
                    <div className="col-2">
                      <div className="fml-box">
                        {this.renderInput("levelTwoQuantity", "Level Two Points", "", "number")}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="col-2">
                        <div className="fml-box">
                          <div className="new-form-group">
                            <label className="form-label">Level Two Rarity</label>
                            <Select
                              name="levelTwoRarity"
                              options={RARITY_OPTIONS}
                              label=""
                              value={this.state.data?.levelTwoRarity}
                              error={this.state.errors?.levelTwoRarity}
                              onChange={this.onChange}
                              isLoading={false}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-2">
                        <div className="fml-box">
                          <div className="new-form-group">
                            <label className="form-label">Level Two Element</label>
                            <Select
                              name="levelTwoElement"
                              options={ELEMENT_OPTIONS}
                              label=""
                              value={this.state.data?.levelTwoElement}
                              error={this.state.errors?.levelTwoElement}
                              onChange={this.onChange}
                              isLoading={false}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </fieldset>
              <fieldset className="row fieldset">
                <div className="row">
                  <div className="col-3">
                    <div className="fml-box">
                      {this.renderInput("levelThreeScore", "Level Three Score", "", "number")}
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fml-box">
                      {this.renderInput("levelThreeMultiplier", "Level Three Multiplier", "", "number")}
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="fml-box">
                      <div className="new-form-group">
                        <label className="form-label">Level Three Prize Type</label>
                        <Select
                          name="levelThreePrizeType"
                          options={this.prizesOptions}
                          label=""
                          value={this.state.data?.levelThreePrizeType}
                          error={this.state.errors?.levelThreePrizeType}
                          onChange={this.onChange}
                          isLoading={false}
                        />
                      </div>
                    </div>
                  </div>
                  {this.state.data?.levelThreePrizeType?.value === "point" ? (
                    <div className="col-2">
                      <div className="fml-box">
                        {this.renderInput("levelThreeQuantity", "Level Three Points", "", "number")}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="col-2">
                        <div className="fml-box">
                          <div className="new-form-group">
                            <label className="form-label">Level Three Rarity</label>
                            <Select
                              name="levelThreeRarity"
                              options={RARITY_OPTIONS}
                              label=""
                              value={this.state.data?.levelThreeRarity}
                              error={this.state.errors?.levelThreeRarity}
                              onChange={this.onChange}
                              isLoading={false}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-2">
                        <div className="fml-box">
                          <div className="new-form-group">
                            <label className="form-label">Level Three Element</label>
                            <Select
                              name="levelThreeElement"
                              options={ELEMENT_OPTIONS}
                              label=""
                              value={this.state.data?.levelThreeElement}
                              error={this.state.errors?.levelThreeElement}
                              onChange={this.onChange}
                              isLoading={false}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </fieldset>
              <fieldset className="row fieldset">
                <div className="row">
                  <div className="col-3">
                    <div className="fml-box">
                      {this.renderInput("levelFourScore", "Level Four Score", "", "number")}
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fml-box">
                      {this.renderInput("levelFourMultiplier", "Level Four Multiplier", "", "number")}
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="fml-box">
                      <div className="new-form-group">
                        <label className="form-label">Level Four Prize Type</label>
                        <Select
                          name="levelFourPrizeType"
                          options={this.prizesOptions}
                          label=""
                          value={this.state.data?.levelFourPrizeType}
                          error={this.state.errors?.levelFourPrizeType}
                          onChange={this.onChange}
                          isLoading={false}
                        />
                      </div>
                    </div>
                  </div>
                  {this.state.data?.levelFourPrizeType?.value === "point" ? (
                    <div className="col-2">
                      <div className="fml-box">
                        {this.renderInput("levelFourQuantity", "Level Four Points", "", "number")}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="col-2">
                        <div className="fml-box">
                          <div className="new-form-group">
                            <label className="form-label">Level Four Rarity</label>
                            <Select
                              name="levelFourRarity"
                              options={RARITY_OPTIONS}
                              label=""
                              value={this.state.data?.levelFourRarity}
                              error={this.state.errors?.levelFourRarity}
                              onChange={this.onChange}
                              isLoading={false}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-2">
                        <div className="fml-box">
                          <div className="new-form-group">
                            <label className="form-label">Level Four Element</label>
                            <Select
                              name="levelFourElement"
                              options={ELEMENT_OPTIONS}
                              label=""
                              value={this.state.data?.levelFourElement}
                              error={this.state.errors?.levelFourElement}
                              onChange={this.onChange}
                              isLoading={false}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </fieldset>
              <fieldset className="row fieldset">
                <div className="col-9">
                  <div className="row">
                    <div className="col-4">
                      <div className="fml-box">
                        <div className="new-form-group">
                          <label className="form-label">Mission Reward Type</label>
                          <Select
                            name="missionCompletedRewardType"
                            options={this.missionCompletedRewardTypeOptions}
                            label=""
                            value={this.state.data?.missionCompletedRewardType}
                            error={this.state.errors?.missionCompletedRewardType}
                            onChange={this.onChange}
                            isLoading={false}
                          />
                        </div>
                      </div>
                    </div>

                    {this.state.data?.missionCompletedRewardType?.value !== 3 ? (
                      <div className="col-4">
                        <div className="fml-box">
                          {this.renderInput("missionCompletedReward", "Mission Completed Reward", "", "number")}
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="col-4">
                          <div className="fml-box">
                            <div className="new-form-group">
                              <label className="form-label">Mission Completed Reward Rarity</label>
                              <Select
                                name="missionCompletedRewardRarity"
                                options={RARITY_OPTIONS}
                                label=""
                                value={this.state.data?.missionCompletedRewardRarity}
                                error={this.state.errors?.missionCompletedRewardRarity}
                                onChange={this.onChange}
                                isLoading={false}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="fml-box">
                            <div className="new-form-group">
                              <label className="form-label">Mission Completed Reward Element</label>
                              <Select
                                name="missionCompletedRewardElement"
                                options={ELEMENT_OPTIONS}
                                label=""
                                value={this.state.data?.missionCompletedRewardElement}
                                error={this.state.errors?.missionCompletedRewardElement}
                                onChange={this.onChange}
                                isLoading={false}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </fieldset>
              <div className="new-form-group"></div>{" "}
              <div className="new-form-group">{this.renderTextarea("description", "How It Works", "")}</div>{" "}
              <div className="new-form-group">
                <div className="kt-upload-row d-flex flex-wrap align-items-start">
                  {!this.state.loadingTelegramAppImage ? (
                    <div
                      className={`kt-upload-outer kt-upload-outer-banner-3 ${
                        !this.state.data.telegramAppImage?.original
                          ? "placeholder-uploaded-img"
                          : "kt-upload-outer-banner-2-h-100  position-relative"
                      } ${this.state.errors.telegramAppImage && "border-error"}`}
                    >
                      <div className="kt-upload-img" htmlFor="uploadImg">
                        <img
                          src={
                            this.state.data.telegramAppImage?.original
                              ? process.env.REACT_APP_CDN + this.state.data.telegramAppImage.original
                              : plusIcon
                          }
                          alt=""
                        />
                      </div>
                      <div
                        className="delete-icon d-flex align-items-center justify-content-center"
                        onClick={(e) => {
                          const data = this.state.data;
                          data.telegramAppImage = "";
                          this.setState({ data });
                        }}
                      >
                        <img src={deleteIcon} alt="delete" />
                      </div>
                    </div>
                  ) : (
                    <div className="kt-upload-outer  kt-upload-outer-banner-3 position-relative loading">
                      <div className="lottie-player-box">
                        <Lottie background="transparent" speed="1" loop autoplay animationData={placeholderJson} play />
                      </div>
                    </div>
                  )}
                  <div className="kt-file-input">
                    <label htmlFor="formFile7" className="kt-label" id="uploadImg">
                      {this.state.data.telegramAppImage?.original
                        ? " Change Telegram Game Image"
                        : "+ Upload Telegram Image"}
                    </label>{" "}
                    ( Recommended size: 512 x 512 )
                    <input
                      className="form-control d-none"
                      type="file"
                      id="formFile7"
                      onChange={(e) => this.handleImageChange(e, "telegramAppImage")}
                    />
                  </div>
                </div>
              </div>
              <div className="new-form-group">
                <div className="kt-upload-row d-flex flex-wrap align-items-start">
                  {!this.state.loadingTelegramMissionImage ? (
                    <div
                      className={`kt-upload-outer kt-upload-outer-banner ${
                        !this.state.data.telegramMissionImage ? "placeholder-uploaded-img" : " position-relative"
                      } ${this.state.errors.telegramMissionImage && "border-error"}`}
                    >
                      <div className="kt-upload-img" htmlFor="uploadImg">
                        <img
                          src={
                            this.state.data.telegramMissionImage
                              ? process.env.REACT_APP_CDN + this.state.data.telegramMissionImage.original
                              : plusIcon
                          }
                          alt=""
                        />
                      </div>
                      <div
                        className="delete-icon d-flex align-items-center justify-content-center"
                        onClick={(e) => {
                          const data = this.state.data;
                          data.telegramMissionImage = null;
                          this.setState({ data });
                        }}
                      >
                        <img src={deleteIcon} alt="delete" />
                      </div>
                    </div>
                  ) : (
                    <div className="kt-upload-outer  kt-upload-outer-banner position-relative loading">
                      <div className="lottie-player-box">
                        <Lottie background="transparent" speed="1" loop autoplay animationData={placeholderJson} play />
                      </div>
                    </div>
                  )}
                  <div className="kt-file-input">
                    <label htmlFor="formFile8" className="kt-label" id="uploadImg">
                      {this.state.data.telegramMissionImage
                        ? " Change Telegram Mission Image"
                        : "+ Upload Telegram Mission Image"}
                    </label>{" "}
                    ( Recommended size: 341 x 192 )
                    <input
                      className="form-control d-none"
                      type="file"
                      id="formFile8"
                      onChange={(e) => this.handleImageChange(e, "telegramMissionImage")}
                    />
                  </div>
                </div>
              </div>
              <div className="new-form-group new-form-btn text-end">
                <NextButton
                  handleSubmit={this.handleSubmit}
                  label="Save"
                  loading={this.state.loadingBGGame}
                  classData={"btn btn-default"}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  addBGGame: (data, callback) => dispatch(addBGGame(data, callback)),
  loadBGGames: (callback) => dispatch(loadBGGames(callback)),
  updateBGGame: (data, id, callback) => dispatch(updateBGGame(data, id, callback)),
  loadSettings: (callback) => dispatch(loadSettings(callback)),
});
const mapStateToProps = (state) => ({
  getGame: getGame(state),
  getSettings: getSettings(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddBGGame));
